import DocsConfig from '@tencent/docs-config';
var appConfigInstance = DocsConfig.getInstance();
/**
 * CAC 配置的 domain
 * 注意在某些私有化场景下，可能是 IP/PORT 或者包含固定前缀的，比如 `127.0.0.1:8080` 或者 `www.test.com/txdocs`
 */

export var currentDomainName = appConfigInstance.getConfig('runtime.domainName') || window.location.hostname;